/**
 * This function removes all the null values from the object.
 * @param {Object} obj - The object to remove the null values from.
 * @returns {Object} - The object with the null values removed.
 */
export const removeNullValueFromObject = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null)
  );
};

/**
 * This function removes all null, undefined, and empty string values from the object.
 * @param {Object} obj - The object to remove the empty values from.
 * @returns {Object} - The object with the empty values removed.
 */
export const removeEmptyValuesFromObject = (obj) => {
  return Object.fromEntries(
    // Convert the object into an array of [key, value] pairs
    Object.entries(obj)
      // Filter the entries based on the value
      .filter(([_, value]) => {
        // Check if the value is not null or undefined.
        // Using != null checks for both null and undefined.
        const isNotNullOrUndefined = value != null;
        // Check if the value is not an empty string.
        // This condition is true if the value is not a string OR if it's a string but not empty.
        const isNotEmptyString = typeof value !== 'string' || value !== '';
        // Keep the entry only if both conditions are true
        return isNotNullOrUndefined && isNotEmptyString;
      })
  );
};
